import type { Stage } from './flow';

export interface HomeProps {
  onBack: () => void;
  onRules: (gmId: string) => void;
  onResume: (attemptId: string) => void;
  onResults: (gmId: string) => void;
}

export const REFRESH_STAGES: Stage['kind'][] = [
  'upcoming',
  'ready',
  'paused',
  'submitted',
  'in_progress',
];
